const state = {
  /**
   * 当前时间戳
   */
  nowTime: Date.now(),
  pageInit: false,
  pageLoading: false,
  /**
   * 是否为移动端
   */
  // isMobile: /iphone|android|ucweb|ucbrowser|nokia|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|mobile/i.test(navigator.userAgent.toLowerCase()),
  isMobile: true,
  /**
   * 登录的用户
   */
  loginUser: null,
  /**
   * layout 导航
   */
  layoutNav: {
    notice: {},
    header: [],
    footer: [],
    bus: []
  },
  /**
   * 下线通知 弹框的状态
   */
  offlineModalStatus: false,
  /**
   * 手机区号列表
   */
  phoneList: [],
  /**
   * 活动报名状态
   * 0 未报名
   * 1 表单提交成功
   */
  activityStatus: 0,
  pageAction: null,
  userInfo: null,
  /**
   * 表单使用哪个平台进行登录,界面上会根据此值显示不一样的登录，发送验证码或者登录接口需要判断不同的appid
   * infoq/time/biz
   */
  loginDomain: 'infoq'
}

export default state
